import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { parseOpportunitiesSearch } from '@/components/opportunities/opportunities-search-schema'
import { OpportunitiesWorkspace } from '@/components/opportunities/opportunities-workspace'
import { PipelineReport } from '@/components/opportunities/pipeline-report'
import { PageHeader } from '@/components/page-header'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export const Route = createFileRoute('/_app/opportunities/')({
  validateSearch: parseOpportunitiesSearch,
  component: OpportunitiesPage,
})

function OpportunitiesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="space-y-6">
      <PageHeader title="Affaires" documentTitle="Affaires" />
      <Tabs
        value={search.onglet ?? 'pipeline'}
        onValueChange={(value) => {
          void navigate({
            search: (current) => ({
              ...current,
              onglet:
                value === 'rapport' ? 'rapport' : value === 'annulees' ? 'annulees' : undefined,
            }),
          })
        }}
      >
        <TabsList>
          <TabsTrigger value="pipeline">Pipeline</TabsTrigger>
          <TabsTrigger value="rapport">Rapport</TabsTrigger>
          <TabsTrigger value="annulees" data-testid="onglet-annulees">
            Annulées
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline">
          <Frame>
            <OpportunitiesWorkspace
              search={search}
              onSearchChange={(next) => {
                void navigate({ search: (current) => ({ ...current, ...next }) })
              }}
            />
          </Frame>
        </TabsContent>
        <TabsContent value="rapport">
          <Frame>
            <PipelineReport />
          </Frame>
        </TabsContent>
        <TabsContent value="annulees">
          <Frame>
            <OpportunitiesWorkspace
              search={search}
              onSearchChange={(next) => {
                void navigate({ search: (current) => ({ ...current, ...next }) })
              }}
            />
          </Frame>
        </TabsContent>
      </Tabs>
    </div>
  )
}
